"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortAndFilterMealTypes = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/**
 * Прости меня боже за такие костыли.
 * Данный костыль сортирует по цене внутри номера. Чтобы избавится от этого костыля, который нагружает компоненты придется затрагивать и переписывать почти всю матрицу,
 * чтобы убрать mealTypes и передавать offers не как объекта, а как отсортированный массив.
 * Так что если будете убирать код ниже и оставлять сортировку по цене, а не по типу питания учитывайте при переписывании пункты выше.
 */
var sortAndFilterMealTypes = exports.sortAndFilterMealTypes = function sortAndFilterMealTypes(mealTypes, item, searchedNights) {
  // функция которая выдает отсортированный массив цен на выбранное кол-во ночей для типа питания
  var getCurrentDateOfferPrices = function getCurrentDateOfferPrices(mealType) {
    var offer = item.offers[mealType.id];
    var currentDateOfferPrices = offer.filter(function (_ref) {
      var nights_count = _ref.nights_count;
      return nights_count === searchedNights;
    }).map(function (_ref2) {
      var price = _ref2.price;
      return price;
    }).sort(function (a, b) {
      return a - b;
    });
    return currentDateOfferPrices;
  };

  // функция сравнения для сортировки типов питания внутри комнаты
  var compareMealTypes = function compareMealTypes(mealTypeA, mealTypeB) {
    var currentDateOfferPricesA = getCurrentDateOfferPrices(mealTypeA);
    var currentDateOfferPricesB = getCurrentDateOfferPrices(mealTypeB);
    if (currentDateOfferPricesA.length === 0 && currentDateOfferPricesB.length === 0) {
      return 0;
    }
    if (currentDateOfferPricesA.length === 0 && currentDateOfferPricesB.length > 0) {
      return 1;
    }
    if (currentDateOfferPricesA.length > 0 && currentDateOfferPricesB.length === 0) {
      return -1;
    }
    return currentDateOfferPricesA[0] - currentDateOfferPricesB[0];
  };

  // проверяем mealType на соответствие требованиям
  if (!(mealTypes && Array.isArray(mealTypes))) {
    return mealTypes;
  }
  // проверяем item на соответствие требованиям
  if (!(item && (0, _typeof2["default"])(item) === 'object' && 'offers' in item)) {
    return mealTypes;
  }
  // проверяем searchedNights на соответствие требованиям
  if (typeof searchedNights !== 'number') {
    return mealTypes;
  }
  return mealTypes
  // убираем из типов питания позиции на которых нет предложений
  .filter(function (mealType) {
    return item.offers[mealType.id];
  }).sort(compareMealTypes);
};